import {
  FETCH_GATING_REQUEST, FETCHING_GATING_SUCCEEDED, FETCHING_GATING_FAILED,
  FETCH_GATINGS_REQUEST, FETCHING_GATINGS_SUCCEEDED, FETCHING_GATINGS_FAILED,
  FETCH_PUBLISHED_GATINGS_REQUEST, FETCH_PUBLISHED_GATINGS_SUCCEEDED, FETCH_PUBLISHED_GATINGS_FAILED,
  CREATE_GATING_REQUEST, CREATING_GATING_SUCCEEDED, CREATING_GATING_FAILED,
  UPDATE_GATING_REQUEST, UPDATING_GATING_SUCCEEDED, UPDATING_GATING_FAILED,
  PUBLISH_GATING_REQUEST, PUBLISHING_GATING_SUCCEEDED, PUBLISHING_GATING_FAILED,
  RESTORE_GATING_REQUEST, RESTORING_GATING_SUCCEEDED, RESTORING_GATING_FAILED,
  CLONE_GATING_REQUEST, CLONING_GATING_SUCCEEDED, CLONING_GATING_FAILED,
  DELETE_GATING_REQUEST, DELETING_GATING_SUCCEEDED, DELETING_GATING_FAILED,
  UPDATE_GATING_SETTINGS, INVALIDATE_GATING_STATE,
  UPDATE_PROGRESSIVE_GATING_PROPERTY,
  UPDATE_GATING_PROGRESSIVE_PROPERTIES,
} from 'constants/actionTypes';

import _ from 'lodash';

const initialState = {
  loading: false,
  fetched: false,
  invalidated: false,
  items: [],
  pagination: {},
  gating: {},
  create: {},
  update: {},
  publish: {
    publishing: false,
    pages: [],
    publishingPages: [],
  },
  deletion: {
    id: null,
    deleting: false,
    deleted: false,
    error: null,
  },
  published: {
    loading: false,
    fetched: false,
    invalidated: false,
    items: [],
    pagination: {},
  },
};

const initialGatingState = {
  loading: false,
  item: null,
  updating: false,
  publishing: false,
  published: false,
  deleting: false,
  hiding:false,
  update: null,
  publish: null
}


export function gatingReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_GATING_REQUEST: {
      const { id }  = action.payload;
      const gatingState = state.gating[id] || initialGatingState;

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            loading: true
          }
        }
      }
    }

    case FETCHING_GATING_SUCCEEDED: {
      const { id, response } = action.payload;
      const gatingState = state.gating[id] || initialGatingState;

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            item: response,
            loading: false
          }
        }
      }
    }

    case FETCHING_GATING_FAILED: {
      const { id, error }  = action.payload;
      const gatingState = state.gating[id] || initialGatingState;

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            loading: false,
            error: error
          }
        }
      }
    }

    case FETCH_GATINGS_REQUEST: {
      const { page }  = action.payload;

      if (page === 0) {
        return {
          ...state,
          loading: true,
          pagination: {
            currentPage: -1,
            totalPages: 1,
            recordsPerPage: 20,
            totalRecordsCount: 0
          }
        }
      }

      return {
        ...state,
        loading: true
      }
    }

    case FETCHING_GATINGS_SUCCEEDED: {
      var items = state.items || [];
      var { currentPage, totalPages, recordsPerPage, totalRecordsCount, records } = action.payload;

      if (currentPage !== 0) {
        items = [...items, ...records];
      } else {
        items = records
      }

      items = _.uniqBy(items, 'id');

      return {
        ...state,
        loading: false,
        fetched: true,
        items: items,
        pagination: {
          ...state.pagination,
          currentPage,
          totalPages,
          recordsPerPage,
          totalRecordsCount
        }
      }
    }

    case FETCHING_GATINGS_FAILED: {
      return {
        ...state,
        loading: false,
        fetched: false,
        error: action.payload
      }
    }

    case FETCH_PUBLISHED_GATINGS_REQUEST: {
      const { page } = action.payload;

      if (page === 0) {
        return {
          ...state,
          published: {
            ...state.published,
            loading: true,
            pagination: {
              currentPage: -1,
              totalPages: 1,
              recordsPerPage: 20,
              totalRecordsCount: 0
            }
          }
        }
      }
      
      return {
        ...state,
        published: {
          ...state.published,
          loading: true
        }
      }
    }

    case FETCH_PUBLISHED_GATINGS_SUCCEEDED: {
      var items = state.items || [];
      var { currentPage, totalPages, recordsPerPage, totalRecordsCount, records } = action.payload;

      if (currentPage !== 0) {
        items = [...items, ...records];
      } else {
        items = records
      }

      items = _.uniqBy(items, 'id');

      return {
        ...state,
        published: {
          ...state.published,
          loading: false,
          fetched: true,
          items: items,
          pagination: {
            ...state.pagination,
            currentPage,
            totalPages,
            recordsPerPage,
            totalRecordsCount
          }
        }
      }
    }

    case FETCH_PUBLISHED_GATINGS_FAILED: {
      return {
        ...state,
        published: {
          ...state.published,
          loading: false,
          fetched: false,
          error: action.payload
        }
      }
    }

    case CREATE_GATING_REQUEST: {
      return {
        ...state,
        create: {
          creating: true,
          success: false
        }
      }
    }

    case CREATING_GATING_SUCCEEDED: {
      const response = action.payload;

      const id = response.id;
      const gatingState = state.gating[response.id] || initialGatingState;

      var gatings = [...state.items, response];

      return {
        ...state,
        items: gatings,
        create: {
          creating: false,
          success: true
        },
        page: {
          ...state.gating,
          [id]: {
            ...gatingState,
            item: response,
            loading: false
          }
        }
      }
    }

    case CREATING_GATING_FAILED: {
      const error = action.payload;

      return {
        ...state,
        create: {
          creating: false,
          success: false
        },
        error: error
      }
    }
    
    case UPDATE_GATING_REQUEST: {
      const { id } = action.payload;

      const gatingState = state.gating[id];
      if(!gatingState) {
        return state;
      }

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            update: {
              updating: true,
              success: false
            }
          }
        }
      }
    }

    case UPDATING_GATING_SUCCEEDED: {
      const { id, response } = action.payload;

      const gatingState = state.gating[id];
      if(!gatingState) {
        return state;
      }

      var items = (state.items || []).map(item => {
        if (item.id === id) {
          return response
        }
        return item;
      })

      return {
        ...state,
        items: items,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            item: response,
            update: {
              updating: false,
              success: true
            }
          }
        }
      }
    }

    case UPDATING_GATING_FAILED: {
      const { id, error } = action.payload;

      const gatingState = state.gating[id];
      if(!gatingState) {
        return state;
      }

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            update: {
              updating: false,
              success: false,
              error: error
            }
          }
        }
      }
    }

    case PUBLISH_GATING_REQUEST: {
      const { id } = action.payload;

      const gatingState = state.gating[id] || initialGatingState;

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            id: id,
            publish: {
              publishing: true,
              success: false
            }
          }
        }
      }
    }

    case PUBLISHING_GATING_SUCCEEDED: {
      const { id, response } = action.payload;

      const gatingState = state.gating[id];
      if (!gatingState) {
        return state;
      }

      var items = (state.items || []).map(item => {
        if (item.id === id) {
          return response
        }
        return item;
      })

      return {
        ...state,
        items: items,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            item: response,
            publish: {
              publishing: false,
              success: true
            }
          }
        }
      }
    }

    case PUBLISHING_GATING_FAILED: {
      const { id, error } = action.payload;
      
      const gatingState = state.gating[id];
      if (!gatingState) {
        return state;
      }

      return {
        ...state,
        page: {
          ...state.gating,
          [id]: {
            ...gatingState,
            publish: {
              publishing: false,
              success: false,
              error: error
            }
          }
        }
      }
    }

    case RESTORE_GATING_REQUEST: {
      const { id } = action.payload;

      const gatingState = state.gating[id];
      if (!gatingState) {
        return state;
      }

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            restore: {
              restoring: true,
              success: false
            }
          }
        }
      }
    }

    case RESTORING_GATING_SUCCEEDED: {
      const { id, response } = action.payload;

      const gatingState = state.gating[id];
      if (!gatingState) {
        return state;
      }

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            item: response,
            restore: {
              restoring: false,
              success: true
            }
          }
        }
      }
    }

    case RESTORING_GATING_FAILED: {
      const { id, error } = action.payload;

      const gatingState = state.gating[id];
      if (!gatingState) {
        return state;
      }

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            restore: {
              restoring: false,
              success: false,
              error: error
            }
          }
        }
      }
    }

    case CLONE_GATING_REQUEST: {
      const { id } = action.payload;

      return {
        ...state,
        cloning: true
      }
    }

    case CLONING_GATING_SUCCEEDED: {
      const { response } = action.payload;

      const gatingState = state.gating[response.id] || initialGatingState;

      return {
        ...state,
        cloning: false,
        gating: {
          ...state.gating,
          [response.id]: {
            ...gatingState,
            item: response
          }
        }
      }
    }

    case CLONING_GATING_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        cloning: false,
        error: error
      }
    }

    case DELETE_GATING_REQUEST: {
      const { id } = action.payload;

      return {
        ...state,
        deletion: {
          ...state.deletion,
          deleting: true,
          deleted: false,
          id: id
        }
      }
    }

    case DELETING_GATING_SUCCEEDED: {
      const { id } = action.payload;

      if (id !== state.deletion.id) {
        return state;
      }

      var gating = _.omit(state.gating, [id]);

      var deletedIndex = (state.items || []).findIndex(item => item.id === id);

      var gatings = (state.items || []).filter(item => {
        return item.id !== id;
      });

      if (deletedIndex >= gatings.length) {
        deletedIndex = 0;
      }

      return {
        ...state,
        gating: gating,
        items: gatings,
        deletion: {
          ...state.deletion,
          deleting: false,
          deleted: true,
          deletedIndex: deletedIndex
        }
      }
    }

    case DELETING_GATING_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.deletion.id) {
        return state;
      }

      return {
        ...state,
        gating: {
          ...state.gating,
          deletion: {
            ...state.deletion,
            deleting: false,
            deleted: false,
            error: error
          }
        }
      }
    }

    case UPDATE_GATING_PROGRESSIVE_PROPERTIES: {
      const { id, progressive } = action.payload || {};

      const updatedGatings = _.get(state, 'items').map(item => {
        if (item.id === id) {
          return {
            ...item,
            progressive
          };
        }
  
        if (item.progressive && progressive) {
          return { ...item, progressive: false };
        }
  
        return item; // preserve reference
      });
  
      return {
        ...state,
        items: updatedGatings,
      }
    }

    case UPDATE_GATING_SETTINGS: {
      const { id, request } = action.payload;

      const gatingState = state.gating[id];
      if (!gatingState) {
        return state;
      }

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            item: {
              ...gatingState.item,
              name: request.name
            }
          }
        }
      }
    }

    case INVALIDATE_GATING_STATE: {
      const id = action.payload;

      const gatingState = state.gating[id];
      if (!gatingState) {
        return state;
      }

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            create: null,
            update: null,
            publish: null,
            restore: null
          }
        }
      }
    }

    /** ------------ PROGRESSIVE GATING ------------ */

    case UPDATE_PROGRESSIVE_GATING_PROPERTY: {
      const { id, property } = action.payload;

      const gatingState = state.gating[id];
      if (!gatingState) {
        return state;
      }

      return {
        ...state,
        gating: {
          ...state.gating,
          [id]: {
            ...gatingState,
            item: {
              ...gatingState.item,
              ...property,
            },
          },
        },
      };
    }

    default: 
      return state;
  } 
}